import { privateAxios } from "../../../config/apiConfig";
import {
  CREATE_ADDRESS_FAILURE,
  CREATE_ADDRESS_REQUEST,
  CREATE_ADDRESS_SUCCESS,
  UPDATE_ADDRESS_FAILURE,
  UPDATE_ADDRESS_REQUEST,
  UPDATE_ADDRESS_SUCCESS,
  UPDATE_BILLING_ADDRESS_FAILURE,
  UPDATE_BILLING_ADDRESS_REQUEST,
  UPDATE_BILLING_ADDRESS_SUCCESS,
  DELETE_ADDRESS_FAILURE,
  DELETE_ADDRESS_REQUEST,
  DELETE_ADDRESS_SUCCESS,
  GET_ADDRESS_FAILURE,
  GET_ADDRESS_REQUEST,
  GET_ADDRESS_SUCCESS,
  GET_VALIDATE_ADDRESS_SUCCESS,
  GET_VALIDATE_ADDRESS_REQUEST,
  GET_VALIDATE_ADDRESS_FAILURE,
  GET_ACTIVE_ADDRESS_REQUEST,
  GET_ACTIVE_ADDRESS_SUCCESS,
} from "./ActionType";
import { toast } from "react-toastify";

// Helper function for error handling
const handleError = (error, failureActionType, dispatch) => {
  const errorMessage =
    error?.response?.data?.response || "An unexpected error occurred";
  toast.error(errorMessage);
  dispatch({ type: failureActionType, payload: errorMessage });
};

export const getUserActiveAddress = () => async (dispatch) => {
  dispatch({ type: GET_ACTIVE_ADDRESS_REQUEST });

  try {
    const response = await privateAxios.get(`user/address/user`);
    const address = response?.data;
    if (address?.status === "SUCCESS") {
      dispatch({ type: GET_ACTIVE_ADDRESS_SUCCESS, payload: address?.response });
    }
  } catch (error) {
    console.error(error)
  }
};

export const createAddress = (addressData, handleCloseAddressForm, setSelectedAddress = () => { }) => async (dispatch) => {
  dispatch({ type: CREATE_ADDRESS_REQUEST });
  try {
    const { data } = await privateAxios.post(`user/address`, addressData);

    // ✅ Check if response contains data before proceeding
    if (!data?.id) {
      throw new Error("Address creation failed! No ID received.");
    }
    dispatch(getUserActiveAddress())
    dispatch({ type: CREATE_ADDRESS_SUCCESS, payload: data });
    handleCloseAddressForm && handleCloseAddressForm();
    if (setSelectedAddress) {
      setSelectedAddress(data); // या जो भी काम हो
    }

  } catch (error) {
    handleError(error, CREATE_ADDRESS_FAILURE, dispatch);

    // ✅ Stop execution if error occurs
    return;
  }
};

export const updateAddress = (addressId, addressData, handleCloseAddressForm) => async (dispatch) => {
  dispatch({ type: UPDATE_ADDRESS_REQUEST });
  try {
    const { data } = await privateAxios.put(`user/address/${addressId}`, addressData);

    if (data?.status === "SUCCESS") {
      dispatch(getUserActiveAddress())
      dispatch({ type: UPDATE_ADDRESS_SUCCESS, payload: data });
      handleCloseAddressForm();
    } else {
      toast.error(data?.response || "Failed to update the address.");
    }
  } catch (error) {
    handleError(error, UPDATE_ADDRESS_FAILURE, dispatch);
  }
};

export const updateBillingAddress = (addressId, addressData, handleCloseAddressForm, setSelectedAddress = () => { }) => async (dispatch) => {
  dispatch({ type: UPDATE_BILLING_ADDRESS_REQUEST });
  try {
    const { data } = await privateAxios.put(`user/address/${addressId}/billing`, addressData);

    if (data?.status === "SUCCESS") {
      getAddress(data.response.id)
      dispatch(getUserActiveAddress())
      dispatch({ type: UPDATE_BILLING_ADDRESS_SUCCESS, payload: data.response });
      handleCloseAddressForm && handleCloseAddressForm();
      if (setSelectedAddress) {
        setSelectedAddress(data?.response); // या जो भी काम हो
      }
    } else {
      toast.error(data?.response || "Failed to update the billing address.");
    }
  } catch (error) {
    handleError(error, UPDATE_BILLING_ADDRESS_FAILURE, dispatch);
  }
};

export const deleteAddress = (addressId) => async (dispatch) => {
  dispatch({ type: DELETE_ADDRESS_REQUEST });
  try {
    const { data } = await privateAxios.put(`user/address/${addressId}/inactive`);

    if (data?.status === "SUCCESS") {
      dispatch(getUserActiveAddress())
      dispatch({ type: DELETE_ADDRESS_SUCCESS, payload: addressId });
    }
  } catch (error) {
    handleError(error, DELETE_ADDRESS_FAILURE, dispatch);
  }
};

export const getAddress = (addressId) => async (dispatch) => {
  dispatch({ type: GET_ADDRESS_REQUEST });
  try {
    const { data } = await privateAxios.get(`user/address/${addressId}`);
    dispatch({ type: GET_ADDRESS_SUCCESS, payload: data });
  } catch (error) {
    handleError(error, GET_ADDRESS_FAILURE, dispatch);
  }
};

export const validateAddressForDelivery = (addressId) => async (dispatch) => {
  dispatch({ type: GET_VALIDATE_ADDRESS_REQUEST });
  try {
    const { data } = await privateAxios.get(`user/address/${addressId}/validate`);
    if (data) {
      dispatch({ type: GET_VALIDATE_ADDRESS_SUCCESS, payload: data });
    }
  } catch (error) {
    handleError(error, GET_VALIDATE_ADDRESS_FAILURE, dispatch);
  }
};
